import { render, staticRenderFns } from "./BuySticker.vue?vue&type=template&id=4d28c011&scoped=true"
import script from "./BuySticker.vue?vue&type=script&lang=js"
export * from "./BuySticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d28c011",
  null
  
)

export default component.exports